import React from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import '../styles/Info.css';

function Info() {
  const features = [
    {
      icon: '📡',
      title: 'Long-Distance Range',
      description: 'Communicate across your entire layout with reliable wireless transmission up to a 1/2 mile in dense forests.'
    },
    {
      icon: '🔋',
      title: 'Low Power Consumption',
      description: 'Battery-powered operation designed for all-day use without frequent charging or battery replacement.'
    },
    {
      icon: '💰',
      title: 'Affordable Pricing',
      description: 'Professional-grade signaling without professional-grade pricing and installation'
    },
    {
      icon: '⚙️',
      title: 'Easy Installation',
      description: 'Get your system running in minutes, not months by avoiding the painful process of trenching 100s of feet of expensive copper wires.'
    },
    {
      icon: '🛡️',
      title: 'Professional Reliability',
      description: 'Built with high-quality components for dependable operation on model railroad layouts.'
    },
    {
      icon: '🔧',
      title: 'Flexible Configuration',
      description: 'LoDis Grows with Your Track. Need another signal? Just add another controller to your system and move the signals.'
    }
  ];

  const specs = [
    { label: 'Wireless Protocol:', value: 'Secure, license-free, interference-resistant protocol' },
    { label: 'Operating Range:', value: 'Up to 1/2 mile in dense forest conditions' },
    { label: 'Power Supply:', value: 'Battery-powered (Car Batteries, Marine Batteries, Power Tool Batteries)' },
    { label: 'Battery Life:', value: '16+ hours of continuous operation' },
    { label: 'Signal Types:', value: 'Compatible with 2-light, 3-light, and custom signal configurations' },
    { label: 'Installation:', value: 'No wiring required - fully wireless setup' },
    { label: 'Firmware Updates:', value: 'Update and Configure Signals using Bluetooth' }
  ];

  return (
    <div className="info-page">
      <Navigation />
      <section className="esp32-section">
        <div className="esp32-container">
          <h1>LoDis Signals Products & Features</h1>
          <p className="esp32-intro">
            Discover our innovative long-distance, low-power wireless signaling systems designed specifically for model railroads. 
            Battery-powered, easy to install, and built for all-day operation.
          </p>

          <div className="esp32-form">
            <h2>Key Features</h2>
            <div className="features-grid">
              {features.map((feature, idx) => (
                <div key={idx} className="feature-card">
                  <div className="feature-icon">{feature.icon}</div>
                  <h4>{feature.title}</h4>
                  <p>{feature.description}</p>
                </div>
              ))}
            </div>

            <h2>User Manual</h2>
            <div className="user-manual-container">
              <iframe 
                src="/LoDis Wireless Controller User Manual.pdf" 
                width="100%" 
                height="800"
                style={{border: '1px solid #ccc'}}
                title="LoDis User Manual"
              ></iframe>
              <p style={{textAlign: 'center', marginTop: '10px'}}>
                <a href="/LoDis Wireless Controller User Manual.pdf" className="cta-link" target="_blank" rel="noopener noreferrer">
                  Download User Manual (PDF)
                </a>
              </p>
            </div>

            <h2>Interested in Getting Started?</h2>
            <a href="/orders#getting-started" className="cta-link">
              <i className="fas fa-arrow-right"></i>
              Check out the Getting Started section on the Orders Page
            </a>

            <div className="showcase-item">
              <h3>Wireless Controller System</h3>
              <p>Professional-grade wireless signal control for your model railroad layout. Operates all day on a single battery charge.</p>
              <div className="demo-video-container">
                <video controls placeholder="https://via.placeholder.com/400x300?text=Video+Placeholder">
                  <source src="" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
                <p className="video-caption">System Overview & Setup</p>
              </div>
            </div>

            <div className="showcase-item">
              <h3>Signal Controller</h3>
              <p>Advanced aspect control with multiple signal configuration options. Compatible with all standard signal types.</p>
              <div className="demo-video-container">
                <video controls placeholder="https://via.placeholder.com/400x300?text=Video+Placeholder">
                  <source src="" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
                <p className="video-caption">Signal Configuration & Operation</p>
              </div>
            </div>

            <div className="showcase-item">
              <h3>Wireless Receiver Module</h3>
              <p>Ultra-low power receiver module with extended range. Pairs seamlessly with all LoDis Signals controllers.</p>
              <div className="demo-video-container">
                <video controls placeholder="https://via.placeholder.com/400x300?text=Video+Placeholder">
                  <source src="" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
                <p className="video-caption">Installation & Configuration</p>
              </div>
            </div>

            <h2>Technical Specifications</h2>
            <div className="notes-box">
              <strong>System Specifications:</strong>
              <ul>
                {specs.map((spec, idx) => (
                  <li key={idx}><strong>{spec.label}</strong> {spec.value}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default Info;
